<template>
    <div>

          <div class="row">
                <div class="col-sm text-center">
                    <div class="card mb-4 border-primary w-100">
                        <div class="card-body">
                            <span style="font-size: 100px; font-weight:800; line-height:60px" 
                                class="text-primary">
                                {{ total_initliased_devices }}  
                            </span> 
                            <br />
                            Total Initliased Devices
                        </div>
                    </div>
                </div>
                <div class="col-sm text-center">
                    <div class="card mb-4 border-warning w-100">
                        <div class="card-body">
                            <span style="font-size: 100px; font-weight:800; line-height:60px" 
                                class="text-warning">
                                {{ total_connected_devices }}
                            </span> 
                            <br />
                            Total Initialising Devices
                        </div>
                    </div>
                </div>

          </div>
          <div class="row">
                <div class="col-sm text-center">
                    <div class="card mb-4 w-100">
                        <div class="card-body">
                            <span style="font-size: 100px; font-weight:800; line-height:60px" 
                                class="text-muted">
                                {{ average_event_process_rate }}
                            </span> 
                            <br />
                            Average Event Process per Minute
                        </div>
                    </div>
                </div>
                <div class="col-sm text-center">
                    <div class="card mb-4 w-100">
                        <div class="card-body">
                            <span style="font-size: 100px; font-weight:800; line-height:60px" 
                                class="text-muted">
                                {{ average_item_process_rate }}
                            </span> 
                            <br />
                            Average Item Process per Minute
                        </div>
                    </div>
                </div>
            </div>

    </div>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        data() {
            return {
            };
        },

        computed: {
            ...mapState({
                servers: state => state.servers
            }),

            total_initliased_devices() {
                return this.servers.reduce((total, server) => {
                    return server.statistics.InitliasedDevices ? total + Number(server.statistics.InitliasedDevices) : total;
                }, 0);
            },

            total_connected_devices() {
                return this.servers.reduce((total, server) => {
                    return server.statistics.ConnectedDevices ? total + server.statistics.ConnectedDevices : total;
                }, 0);
            },

            average_event_process_rate() {
                var rate = this.servers.reduce((total, server) => {
                    return server.statistics.EventsProcessedAverage && !server.timeout ?
                        total + Number(server.statistics.EventsProcessedAverage) : total
                }, 0);

                return +(Math.round(rate + "e+2") + "e-2")
            },

            average_item_process_rate() {
                var rate = this.servers.reduce((total, server) => {
                    return server.statistics.ItemsProcessedAverage && !server.timeout ?
                        total + Number(server.statistics.ItemsProcessedAverage) : total
                }, 0);

                return +(Math.round(rate + "e+2") + "e-2")
            },

            total_comms_engines() {
                return this.servers.reduce((total, server) => {
                    return server.type == "Comms Engine" ? total + 1 : total;
                }, 0);
            },

            total_loggers() {
                return this.servers.reduce((total, server) => {
                    return server.type == "Logger" ? total + 1 : total;
                }, 0);
            }
        },
    }
</script>

<style>
</style>
